// Vendor Libs
import {cloneDeep} from 'lodash';

const initialState = {
    fetched: false,
    fetching: false,
    error: null,
    response: null,
};

function getInitialState() {
  return cloneDeep(initialState);
}

const actions = {
    REQUEST_PASSWORD: () => ({...getInitialState(), fetching: true}),

    REQUEST_PASSWORD_FULFILLED: (state, {response}) => ({
        ...state,
        error: null,
        fetched: true,
        fetching: false,
        response,
    }),

    REQUEST_PASSWORD_REJECTED: (state, {error}) => ({
        ...state,
        fetched: true,
        fetching: false,
        error,
    }),

    REQUEST_PASSWORD_FORM_RESET: () => getInitialState(),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
